// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var EPublishType;
(function (EPublishType) {
    EPublishType["Event"] = "event";
    EPublishType["Election"] = "election";
})(EPublishType || (EPublishType = {}));
export var EPublishActionsType;
(function (EPublishActionsType) {
    EPublishActionsType["List"] = "list";
    EPublishActionsType["Generate"] = "generate";
})(EPublishActionsType || (EPublishActionsType = {}));
